


import React, { Component, useContext, useState, useEffect, useRef, Fragment } from "react";
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Tap from 'react-interactions';
import { makeStyles, useStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import styled, {css} from 'styled-components';

import { ProductContext } from '../../context'
import Product from './Product'

import {CssMenu, CssMenuLi, CssMenuBorder} from '../Popup'
import { relative } from 'path';

import { Scrollbars } from 'react-custom-scrollbars';

import '../swiper.css'







export default function ListRegular ({
  id = 'swiper0',
  products = [],
  theme,
  cardWidth,
  cardType,
  template,
}) {

//  console.log('products = ', products);


  let count = 0;

  return (
    <СssGroup
    theme={theme}
    cardWidth={cardWidth}
    cardType={cardType}
  >
{
  products.map((oneProduct, i) => {
    count = count + 1;
    return (
      <Product
        {...oneProduct}
        theme={theme}
        cardWidth={cardWidth}
        theme={theme}
        cardType={cardType}

        key={oneProduct.sku}
        template={template}
        id={oneProduct.id}
        order={count}
        initClass="initialFlow1"
        sku={oneProduct.sku}
        title={oneProduct.name}

        description={oneProduct.description}
        // price={oneProduct.amount}
        // priceFull={oneProduct.amount_without_discount || oneProduct.amount}
        discountPercent={oneProduct.discount_percent}
        image_url={oneProduct.image_url}
        currency={oneProduct.currency}
        product={oneProduct}
        is_favorite = {oneProduct.is_favorite || 0}
        in_cart = {oneProduct.in_cart || 0}
      />
    )
  })
}
      </СssGroup>
  )




}








const СssGroup = styled.div`



  ${({cardType, theme}) => cardType !== 'cart' && css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${({cardWidth}) => cardWidth ? cardWidth : 200}px, 1fr));
    /* grid-template-columns: repeat(
    ${({cardWidth}) => cardWidth ? (parseInt((window.innerWidth - 400) / cardWidth, 0)) : 4}, minmax(240px, 1fr)); */

    grid-auto-rows: ${({cardWidth}) => cardWidth ? parseInt(cardWidth , 0) + parseInt(cardWidth/1.4, 0) : 240}px;
    grid-column-gap: ${({cardWidth}) => parseInt(cardWidth / 8, 0)}px;
    grid-row-gap: ${({cardWidth}) => parseInt(cardWidth / 3, 0)}px;
    /* grid-column-gap: ${({theme}) => theme["cardPadding"]}px; */
    /* grid-row-gap: ${({theme}) => theme["cardPadding"]}px; */
    /* grid-template-rows: repeat(auto-fill, minmax(${({cardWidth}) => cardWidth ? cardWidth : 200}px, 1fr)); */
    /* grid-template-columns: repeat(auto-fill, ${({cardWidth}) => cardWidth ? cardWidth : 200}px); */


    @media (max-width: 479px) {
      grid-template-columns: repeat(auto-fill, minmax(${({cardWidth}) => cardWidth ? cardWidth / 2 : 100}px, 1fr));
    };
  `}

  ${({cardType, theme, quantity}) => (cardType === 'subscriptions' || cardType === 'currency') && css`
    /* grid-template-columns: repeat(${({quantity}) => quantity}, 1fr); */
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: ${({cardWidth}) => theme ? parseInt(cardWidth , 0) + parseInt(cardWidth , 0)/2 : 240}px;
  `};

  ${({cardType, theme}) => cardType === 'cart' && css`
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 16px;
  `};

  /* grid-template-columns: repeat(${({cardType, quantity}) => cardType === 'subscriptions' ? quantity : 1}, 1fr); */


`